import memoji1 from "./assets/memoji1.png"; //male
import memoji2 from "./assets/memoji2.png"; //female
import memoji3 from "./assets/memoji3.png";
import memoji4 from "./assets/memoji4.png";
import memoji5 from "./assets/memoji5.png";
import memoji1Chat from "./assets/memoji1-chat.png"; //male
import memoji2Chat from "./assets/memoji2-chat.png"; //female
import memoji3Chat from "./assets/memoji3-chat.png";
import memoji4Chat from "./assets/memoji4-chat.png";
import memoji5Chat from "./assets/memoji5-chat.png";
import baristamemoji from "./assets/barista_memoji.png";
import {
  Calendar,
  CreditCard,
  User2,
  PhoneIcon,
  Umbrella,
  Bell,
  Plane,
  User,
  Mail,
  Smartphone,
  SpeakerIcon,
  Camera,
  Headphones,
  Watch,
  Sofa,
  Phone,
  Home,
  IdCardIcon,
  BadgeDollarSign,
  ReceiptIcon,
  IdCard,
  CalendarCheckIcon,
  BadgeCheckIcon,
  PhoneCall,
  Tv,
  Dot
} from "lucide-react";
import {
  VOICEX_URL_CONSTANTS,
  DEFAULT_TENANT_ID,
  DEFAULT_WORKSPACE_ID,
  DEFAULT_USER_ID,
  OLD_TENANT_ID,
  OLD_WORKSPACE_ID,
  OLD_USER_ID,
  STAGE_TENANT_ID,
  STAGE_WORKSPACE_ID,
  STAGE_USER_ID,
  US_TENANT_ID,
  US_WORKSPACE_ID,
  US_USER_ID,
  NURIX_TENANT_ID,
  NURIX_WORKSPACE_ID
} from "./utils/constants";

export const agentCategoriesUs = {
  Default: {
    path: "/*",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "3a0b5e40539697108263058dbaff9277",
        name: "Banking Customer Support",
        agentName: "Pranav",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Bank account inquiry",
          "Lost credit card reporting",
          "Card limit modification"
        ],
        voice: "true",
        chat: "true",
        chatHints: [
          { triggers: ["last 4 digits"], hint: "Account No. ••• •••••• 1234" },
          {
            triggers: ["date of birth", "janm date", "birth date"],
            hint: "Date of Birth 01/02/2000"
          }
        ],
        callHints: [
          { icon: Calendar, name: "Date of Birth", value: "01/02/2000" },
          { icon: CreditCard, name: "Account No.", value: "••• •••••• 1234" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "agent_7e1679684cd8b087cf1151bc0f",
        name: "Insurance Sales Outreach",
        agentName: "Simran",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: [
          "Health insurance policy suggestions",
          "Policy breakdown and comparison",
          "Policy terms elucidation"
        ],
        voice: "true",
        chat: "false",
        demo: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  AIG: {
    path: "/aig",
    pageTitle: "Experience Our TATA AIG Agents",
    agents: [
      {
        id: "2e5a1b34-9967-4d79-80f6-73d7ccb1c98a",
        name: "Service Request for Endorsement",
        agentName: "Monica",
        icon: memoji2,
        chatIcon: memoji1Chat,
        featureList: [],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          { icon: IdCard, name: "Customer's Name", value: "Aayush Sharma" },
          { icon: CalendarCheckIcon, name: "DOB", value: "2nd February, 2000" },
          { icon: BadgeCheckIcon, name: "Policy Number", value: "****1234" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "6c3d53c6-7e72-4617-be46-6772f86425fc",
        name: "Sales and Renewal for Two-wheeler",
        agentName: "Robin",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  EmpireToday: {
    path: "/empire-today",
    pageTitle: "Experience our AI agents",
    agents: [
      {
        id: "7adb4360-ef81-470d-9afa-c2d2308369c1",
        name: "Empire Today FAQ Agent",
        agentName: "Emily",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Answers general, financing & services related FAQs"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  StateFarm: {
    path: "/state-farm",
    pageTitle: "Experience Our AI Agents",
    agents: [
      {
        id: "f762ba03-df81-4526-92bc-a01badb14ea8",
        name: "Customer Support Agent",
        agentName: "Jake",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: ["FAQs Agent"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  InsurancePandC: {
    path: "/insurance/pandc",
    pageTitle: "Experience Our P&C Insurance Agents",
    agents: [
      {
        id: "59129fbe-1b76-4d14-8e6d-ff9212c5c98a",
        name: "Auto Insurance Renewal",
        agentName: "Ethan",
        icon: memoji1,
        chatIcon: memoji1Chat,
        featureList: [
          "Sales Qualification",
          "Policy Updates Collection",
          "Renewal Reminders"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "1bd1139a-e9eb-477f-888e-8484dde139c3",
        name: "Auto Sales Qualification",
        agentName: "Marissa",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: [
          "Gather essential information",
          "Screen potential clients"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "860af836-e47e-4426-8af1-430f8c8c2ebb",
        name: "Auto-Ask your Policy",
        agentName: "Emily",
        icon: memoji3,
        chatIcon: memoji3Chat,
        featureList: ["Answering queries", "Upgrading policy"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          { icon: User2, name: "Last four digits of SSN", value: "5478" },
          { icon: Calendar, name: "DOB", value: "19th February 1986" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "12925c09-3073-4896-8849-8febdb480a8d",
        name: "Home-Ask your Policy",
        agentName: "Myra",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Answering queries", "Upgrading policy"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          { icon: User2, name: "Last four digits of SSN", value: "5478" },
          { icon: Calendar, name: "DOB", value: "19th February 1986" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "8fe0da40-2531-4ecb-9908-96caf7f38f97",
        name: "Home Insurance FNOL",
        agentName: "Sarah",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: ["Register home damage claim", "Collect incident details"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHintsTable: [],
        callHints: [
          { icon: User2, name: "Claimant name", value: "John Doe" },
          { icon: PhoneIcon, name: "Phone Number", value: "555-123-4567" },
          { icon: Umbrella, name: "Policy Number", value: "NRX-1234" },
          { icon: Bell, name: "OTP", value: "123456" }
        ],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  },
  Banking: {
    path: "/banking",
    pageTitle: "Experience Our Banking Agents",
    agents: [
      {
        id: "925a64a9-5b51-4cdc-8adb-1789ec522969",
        name: "Collections Agent",
        agentName: "Maria",
        icon: memoji5,
        chatIcon: memoji5Chat,
        featureList: ["Remind users to pay overdue"],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          { icon: User, name: "Name of User", value: "Mr Robin Smith" },
          { icon: CreditCard, name: "Social security code", value: "3456" },
          { icon: Calendar, name: "Date of Birth", value: "2nd Jan 1998" }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "74abb373-f23b-4936-ab2d-dd1d72aac2f5",
        name: "Banking Customer Support",
        agentName: "Emily",
        icon: memoji3,
        chatIcon: memoji3Chat,
        featureList: [
          "Account transaction support",
          "Credit card transaction support",
          "Credit card upgradation and modification",
          "Language: English"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [
          { icon: IdCard, name: "Last four digits of SSN", value: "5439" },
          {
            icon: CreditCard,
            name: "Last Four digits of Bank Account",
            value: "5438"
          },
          {
            icon: Calendar,
            name: "Last Four digits of Credit Card:",
            value: "1532"
          }
        ],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      },
      {
        id: "02a8e543-3d31-498b-827e-59cc431da127",
        name: "Mortgage Sales Agent",
        agentName: "Marissa",
        icon: memoji4,
        chatIcon: memoji4Chat,
        featureList: [
          "Suggest Best  suited Home Mortgage",
          "Query resolution related to Home Mortgage",
          "Language: English"
        ],
        voice: "true",
        chat: "false",
        chatHints: [],
        callHints: [],
        callHintsTable: [],
        voiceInputs: [],
        voiceProvider: "retell",
        voiceConfig: {}
      }
    ]
  }
};
